import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { parentFind } from "library/tree/index.mjs"
import { PlanRoot } from "library/tree/constants.mjs"
import { getShareLinkCommentRegimeId } from "./share-link-comment-regime-id"

// Resolve the published-regime id for the recipient Comments views from the bound tree item. Shared
// by the Comments tab badge and the recipient panel so the unread query and the thread list always
// target the same regime. Returns `undefined` when the item is not under a resolvable regime.
export function useShareLinkCommentRegimeId() {
    const { parentItem, facility, facilityGroup } = useBoundContext()
    const item = parentItem ?? facility ?? facilityGroup
    return getShareLinkCommentRegimeId({ itemId: item?.id, rootItem: parentFind(item, isPlanRoot) })

    function isPlanRoot(node) {
        return !!node?.[PlanRoot]
    }
}
